import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import type { FormNames } from '../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    VCycleElementDecoratorPropertyValidation,
    type VCycleElementDecoratorResource,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementDecoratorResource';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const VCycleElementDecoratorContent = ({
    id,
    form,
    formNames,
    readOnly,
}: {
    id?: string;
    form: UseFormReturn<VCycleElementDecoratorResource>;
    formNames: FormNames<VCycleElementDecoratorResource>;
    readOnly: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: VCycleElementDecoratorPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.V_CYCLE_ELEMENT_DECORATOR,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Grid.Col span={6}>
                <PropertyInputs.Integer
                    name={formNames.horizontalPriority}
                    control={form.control}
                    nullable={true}
                    placeholder={'1'}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        VCycleElementDecoratorPropertyValidation.HORIZONTAL_PRIORITY
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <PropertyInputs.Integer
                    name={formNames.verticalPriority}
                    control={form.control}
                    nullable={true}
                    placeholder={'1'}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        VCycleElementDecoratorPropertyValidation.VERTICAL_PRIORITY
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <PropertyInputs.Color
                    name={formNames.textColor}
                    control={form.control}
                    placeholder={'default color'}
                    nullable={true}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        VCycleElementDecoratorPropertyValidation.TEXT_COLOR
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <PropertyInputs.Color
                    name={formNames.backgroundColor}
                    control={form.control}
                    placeholder={'default color'}
                    nullable={true}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        VCycleElementDecoratorPropertyValidation.BACKGROUND_COLOR
                    )}
                />
            </Grid.Col>
        </Grid>
    );
};
